import { Checkbox } from '@cian/ui-kit';

import * as React from 'react';

import { ECommissionType } from '@/packages/api-models/common/json_query';

import { RadioButtonGroup } from '../../RadioButtonGroup';
import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';

interface ICommissionTypeOption {
  label: string;
  value: ECommissionType | null;
}

const COMMISSION_OPTIONS: ICommissionTypeOption[] = [
  { label: 'Неважно', value: null },
  { label: 'Без комиссии', value: ECommissionType.WithoutDeposit },
  { label: 'Эксклюзивная', value: ECommissionType.Exclusive },
];

interface ICommissionProps {
  commission: ECommissionType | null;
  withoutAgentsCalls: boolean | null;
  onCommissionChange(value: ECommissionType | null): void;
  onWithoutAgentsCallsChange(value: boolean | null): void;
}

export const Commission: React.FC<ICommissionProps> = ({
  commission,
  withoutAgentsCalls,
  onCommissionChange,
  onWithoutAgentsCallsChange,
}) => {
  return (
    <Filter id="advancedFilter_commission" label="Комиссия">
      <InlineFilterGroup>
        <InlineFilter>
          <RadioButtonGroup options={COMMISSION_OPTIONS} value={commission} onChange={onCommissionChange} />
        </InlineFilter>
        <InlineFilter>
          <Checkbox
            checked={withoutAgentsCalls === false}
            label="Без «Агентам не звонить»"
            onChange={event => onWithoutAgentsCallsChange(event.target.checked ? false : null)}
          />
        </InlineFilter>
      </InlineFilterGroup>
    </Filter>
  );
};
